// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cadenceIcon-module___container___vIH8k {\n  height: 60px;\n  width: 60px;\n}\n", "",{"version":3,"sources":["webpack://./src/js/components/cadenceControlModal/cadenceIcon/cadenceIcon.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":["._container {\n  height: 60px;\n  width: 60px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"_container": "cadenceIcon-module___container___vIH8k"
};
export default ___CSS_LOADER_EXPORT___;
